import { Link } from "react-router-dom";
import { Play, Layers } from "lucide-react";
import { mediaUrl } from "@/lib/api";

export const LookCard = ({ look, index = 0, featured = false }) => (
  <Link
    to={`/looks/${look.id}`}
    data-testid={`look-card-${look.id}`}
    className={`group relative block overflow-hidden rounded-sm bg-[#141417] border border-white/5 hover:border-[#D4AF37]/40 transition-all duration-500 fade-up ${
      featured ? "aspect-[16/10]" : "aspect-[3/4]"
    }`}
    style={{ animationDelay: `${index * 0.06}s` }}
  >
    <img
      src={mediaUrl(look.hero_thumbnail)}
      alt={look.title}
      className="absolute inset-0 w-full h-full object-cover img-zoom"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />

    <div className="absolute top-4 left-4 flex items-center gap-2">
      <span className="flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-[0.15em] px-2.5 py-1 rounded-full bg-black/50 backdrop-blur border border-white/15">
        <Layers size={11} /> {look.product_count ?? 0} items
      </span>
    </div>

    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-all duration-500 scale-90 group-hover:scale-100">
      <span className="flex items-center justify-center w-14 h-14 rounded-full bg-[#D4AF37] text-black">
        <Play size={20} fill="currentColor" className="ml-0.5" />
      </span>
    </div>

    <div className="absolute bottom-0 inset-x-0 p-6">
      <p className="overline mb-2">{(look.category_summary || []).slice(0, 2).join(" · ") || "Look"}</p>
      <h3 className="font-serif text-2xl lg:text-3xl font-light text-[#F8F6F0] group-hover:text-[#D4AF37] transition-colors duration-300">
        {look.title}
      </h3>
    </div>
  </Link>
);
